function isExpectedNotFound(error) {
  return error?.statusCode === 404 || error?.cause?.statusCode === 404
}

export default defineNuxtPlugin((nuxtApp) => {
  const currentPath = () => {
    try {
      return useRoute().fullPath
    } catch {
      return 'unknown path'
    }
  }

  // Chain rather than overwrite: Sentry's Nuxt module also sets config.errorHandler,
  // and wraps whatever was already there. Overwriting it here (regardless of plugin
  // load order) would silently stop Sentry from capturing Vue errors.
  const existingErrorHandler = nuxtApp.vueApp.config.errorHandler

  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    if (isExpectedNotFound(error)) {
      console.warn(`[404] ${currentPath()}`)
    } else {
      console.error('Error occurred:', error, 'Error info:', info, 'Path:', currentPath())
    }
    existingErrorHandler?.(error, instance, info)
  }

  nuxtApp.hook('vue:error', (error, instance, info) => {
    if (isExpectedNotFound(error)) return
    console.error('Error occurred:', error, 'Error info:', info, 'Path:', currentPath())
  })

  nuxtApp.hook('render:errorMiddleware', (error) => {
    if (isExpectedNotFound(error)) return
    console.error('SSR Error:', error, 'Path:', currentPath())
  })

  nuxtApp.hook('app:error', (error) => {
    if (isExpectedNotFound(error)) return
    console.error('App Error:', error, 'Path:', currentPath())
  })
})
